export class FilterOperators {

  static readonly Equal = 'equal';
  static readonly NotEqual = 'not equal';
  static readonly In = "in";
  static readonly NotIn = 'not in';
  static readonly Contains = 'contains';
  static readonly DoesNotContain = 'does not contain';
  static readonly IsEmpty = 'empty';

  static readonly Between = 'between';
  static readonly BetweenNumber = 'betweenNumber';
  static readonly BetweenDate = 'betweenDate';

  static readonly GreaterThan = 'greater than';
  static readonly GreaterThanOrEqual = 'greater than or equal';

  static readonly LessThan = 'less than';
  static readonly LessThanOrEqual = 'less than or equal';

  static readonly All = [FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.In, FilterOperators.NotIn, FilterOperators.Contains, FilterOperators.IsEmpty, FilterOperators.GreaterThan, FilterOperators.GreaterThanOrEqual, FilterOperators.LessThan, FilterOperators.LessThanOrEqual, FilterOperators.Between,];

  static readonly Scalar = [FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.IsEmpty, FilterOperators.GreaterThan, FilterOperators.GreaterThanOrEqual, FilterOperators.LessThan, FilterOperators.LessThanOrEqual, FilterOperators.Between, FilterOperators.In, FilterOperators.NotIn];
  static readonly AdminScalar = [FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.IsEmpty, FilterOperators.GreaterThan, FilterOperators.GreaterThanOrEqual, FilterOperators.LessThan, FilterOperators.LessThanOrEqual, FilterOperators.Between];

  static readonly DateDefaults = [FilterOperators.GreaterThanOrEqual, FilterOperators.LessThanOrEqual, FilterOperators.GreaterThan, FilterOperators.LessThan, FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.Between, FilterOperators.In, FilterOperators.NotIn];
  static readonly AdminDateDefaults = [FilterOperators.GreaterThanOrEqual, FilterOperators.LessThanOrEqual, FilterOperators.GreaterThan, FilterOperators.LessThan, FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.Between];

  static readonly StringDefaults = [FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.Contains, FilterOperators.DoesNotContain, FilterOperators.In, FilterOperators.NotIn];
  static readonly AdminStringDefaults = [FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.Contains, FilterOperators.DoesNotContain];

  static readonly CategoryDefaults = [FilterOperators.Equal, FilterOperators.NotEqual, FilterOperators.In, FilterOperators.NotIn];

}



